var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgSync = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17.488,
    height: 18,
    viewBox: "0 0 17.488 18",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.256)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.619,9A7.628,7.628,0,0,1,9,16.619a7.551,7.551,0,0,1-6.026-2.965H6.581V12.529H1.11V18H2.235V14.52A8.661,8.661,0,0,0,9,17.744,8.753,8.753,0,0,0,17.744,9H16.619Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9,1.381a7.55,7.55,0,0,1,6.028,2.965H11.351V5.471h5.471V0H15.7V3.4A8.659,8.659,0,0,0,9,.256,8.753,8.753,0,0,0,.256,9H1.381A7.628,7.628,0,0,1,9,1.381Z"
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgSync);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/sync.aef91db8790f5fbfe5750255c357119c.svg";